import { apiPost, timeLimitedApiPost, apiGet, apiPut, ApiError } from './fetch';
import { DeviceId, CameraCommand, UtcTime, SeekType, CameraMessage, StreamIndex } from 'types';
import { baseUrl } from './baseUrl';
import { formatDate } from 'api';


const validateDeviceId = (deviceId: string) => {
    if (!deviceId) {
        // This should never happen!
        console.error('deviceId is missing!');
        throw new ApiError('341'); // Operation failed
    }
};

type PtzLockRequest = {
    deviceId: DeviceId;
    lock: boolean;
};

export const postPtzLock = async (deviceId: DeviceId, lock: boolean) => {
    validateDeviceId(deviceId);
    return await apiPost<PtzLockRequest>(`${baseUrl}/camera/ptz/lock`, { deviceId, lock });
};

type PtzMoveRequest = {
    deviceId: DeviceId;
    x: number;
    y: number;
    z: number;
    speed: number;
};

export const postPtzMove = async (deviceId: DeviceId, x: number, y: number, z: number, speed: number) => {
    validateDeviceId(deviceId);
    return await apiPost<PtzMoveRequest>(`${baseUrl}/camera/ptz/move`, { deviceId, x, y, z, speed });
};

type CameraFnRequest = {
    deviceId: DeviceId;
    commandId: CameraCommand;
};

export const postCameraFn = async (deviceId: DeviceId, commandId: CameraCommand) => {
    validateDeviceId(deviceId);
    return await apiPost<CameraFnRequest>(`${baseUrl}/camera/fn`, { deviceId, commandId });
};

type PtzLocationRequest = {
    deviceId: DeviceId;
    locationId: number;
};

export const postPtzLocation = async (deviceId: DeviceId, locationId: number) => {
    validateDeviceId(deviceId);
    return await apiPost<PtzLocationRequest>(`${baseUrl}/camera/ptz/location`, { deviceId, locationId });
};

type SeekStreamRequest = {
    deviceId: DeviceId;
    streamIndex: StreamIndex;
    utcTime: UtcTime;
    seekType: SeekType;
    showDecorations: boolean;
};

export type SeekStreamResponse = {
    utcTime: UtcTime;
    frame: string; // base-64 image data
};

export const postSeekRequest = async (deviceId: DeviceId, streamIndex: StreamIndex, seekType: SeekType, utcTime: UtcTime, showDecorations: boolean) => {
    validateDeviceId(deviceId);
    const requestBody = { deviceId, streamIndex, seekType, utcTime, showDecorations };
    return await timeLimitedApiPost<SeekStreamRequest, SeekStreamResponse>(`${baseUrl}/camera/seek`, requestBody);
};

export type XmlConfigMap = {
    [locationId: string]: string;
};

export const getCameraAddOnConfig = async (deviceId: DeviceId, addOn: string) => {
    validateDeviceId(deviceId);
    return await apiGet<XmlConfigMap>(`${baseUrl}/camera/${deviceId}/config/${addOn}`);
};

export const putCameraAddOnConfig = async (deviceId: DeviceId, addOn: string, xmlMap: XmlConfigMap) => {
    validateDeviceId(deviceId);
    return await apiPut<XmlConfigMap>(`${baseUrl}/camera/${deviceId}/config/${addOn}`, xmlMap);
};

export const getTimeline = async (deviceId: DeviceId, utcDate: Date, tzOffsetCalculator: (t: UtcTime) => number) => {
    validateDeviceId(deviceId);
    return await apiGet<CameraMessage[]>(`${baseUrl}/camera/${deviceId}/timeline/${formatDate(utcDate, tzOffsetCalculator)}`);
};



// WEBPACK FOOTER //
// ./src/api/camera.ts